import { type CustomCellRendererProps } from "ag-grid-react";

import { Tooltip } from "@synthesis/shared-ui";

export const CellWithTooltip = ({ value, valueFormatted }: CustomCellRendererProps) => {
  const tooltipValue = valueFormatted || value || "—";

  return (
    <Tooltip description={tooltipValue} arrowSide="top">
      <span>{tooltipValue}</span>
    </Tooltip>
  );
};
